import { axiosBaseQuery } from "../axiosBaseQuery";

export const realWorldBaseQuery = axiosBaseQuery({
  baseUrl: "https://api.realworld.io/api",
});
